$transition: 0.1s;

.wrapper {
  background-color: transparent;
  position: relative;
  display: flex;
  align-items: center;
  gap: 6px;

  &:hover:not(.disabled):not(.iconLock) {
    .icon {
      border-color: var(--input-border-color);
    }
    .input:checked + .icon {
      border-color: var(--primary-color);
      background-color: var(--primary-color);
      &:after {
        border-color:  var(--background-color);
      }
    }
  }
}

.label {
  cursor: pointer;
  white-space: pre;
}

.icon {
  transition: all $transition;
  border-radius: 100px;
  cursor: pointer;
  height: 16px;
  width: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid var(--input-border-color);
  background-color: var(--background-color);
  position: relative;
  flex-shrink: 0;

  &:after {
    border: 2px solid var(--background-color);
    border-radius: inherit;
    content: "";
    height: 10px;
    opacity: 0;
    width: 10px;
  }
}

// extra specificiity so it doesn't get overwritten
input[type="radio"].input {
  visibility: hidden;
  position: absolute;
  z-index: -1;
  &:checked + .icon:after {
    opacity: 1;
  }

  &:checked {
    & + .icon {
      border-color: var(--primary-color);
      background-color: var(--primary-color);
    }

    & + .icon svg {
      display: none;
    }
  }
}

.iconLock * {
  cursor: default;
}
.disabled {
  .icon {
    cursor: not-allowed;
  }
  .label {
    cursor: default;
  }
}

.disabled,
.iconLock {
  .icon {
    border-color: var(--input-border-color);
    background-color: var(--secondary-background-color);

    svg {
      flex-shrink: 0;
    }
  }
}

.iconLock {
  .icon:after {
    display: none;
  }
  .input:checked + .icon:after {
    display: block;
  }
}
